<template>
  <div class="container">

    <div class="handle-box-search">
      <div class="handle-box">

        <div>





          <div class="table-head">
            <div style="margin: 10px 0;" class="search-radio">
              <span class="title">账号状态:</span>
              <el-radio-group v-model="search_data.status" size="small">
                <el-radio label="" border>
                  全部</el-radio>
                <el-radio label="0" border>禁用</el-radio>
                <el-radio label="1" border>启用</el-radio>
              </el-radio-group>
            </div>

            <div style="margin: 10px 0;" class="search-radio">
              <span class="title">平台:</span>
              <el-radio-group v-model="search_data.platform" size="small">
                <el-radio label="" border>
                  全部</el-radio>
                <el-radio label="android" border>安卓端</el-radio>
                <el-radio label="ios" border>苹果端</el-radio>
                <el-radio label="h5" border>移动网页</el-radio>
                <el-radio label="wx_cgi" border>微信小程序</el-radio>
              </el-radio-group>
            </div>

            <div style="margin: 10px 0;" class="search-radio">
              <span class="title">性别:</span>
              <el-radio-group v-model="search_data.sex" size="small">
                <el-radio label="" border>
                  全部
                </el-radio>
                <el-radio label="1" border>男</el-radio>
                <el-radio label="0" border>女</el-radio>
                <el-radio label="2" border>未知</el-radio>
              </el-radio-group>
            </div>

            <div style="margin: 10px 0;display: flex;" class="search-radio">

              <div>
                <span class="title">注册时间:</span>

                <el-radio-group v-model="reg_time_value" size="small" @change="regTimeChange">
                  <el-radio label="" border>
                    全部</el-radio>
                  <el-radio label="today" border>今天</el-radio>
                  <el-radio label="yesterday" border>昨天</el-radio>
                  <el-radio label="this_week" border>本周</el-radio>
                  <el-radio label="last_week" border>上周</el-radio>
                  <el-radio label="this_month" border>本月</el-radio>
                  <el-radio label="last_month" border>上月</el-radio>
                  <el-radio label="between" border>自定义时间</el-radio>
                </el-radio-group>

              </div>

              <el-date-picker v-if="reg_time_value == 'between'" v-model="reg_time_array" type="datetimerange"
                range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange">
              </el-date-picker>


            </div>



          </div>

        </div>



        <el-row type="flex" justify="space-between">

          <el-col :span="22">
            <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics" style="padding: 6px 12px;">搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="refresh" style="padding: 6px 12px;">重置
            </el-button>
          </el-col>



        </el-row>

      </div>

    </div>

    <div class="charts-box">

      <div id="totalCharts" style="width: 50%;height: 400px;"></div>



      <div id="amountCharts" style="width: 50%;height: 400px;"></div>

    </div>


  </div>

</template>

<script>
  var _this;
  import echarts from 'echarts'
  export default {
    data() {
      return {



        reg_time_value: '',
        reg_time_array: [],

        company_name: '',


        totalCharts: '',
        totalOption: {
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: ['司机总数量'],
            axisTick: {
              alignWithLabel: true
            }
          }],
          yAxis: [{
            type: 'value'
          }],
          series: [{
            name: '司机总数量',
            type: 'bar',
            barWidth: '60%',
            data: [],
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = [
                    "#c23531",
                    "#2f4554",
                    "#61a0a8",
                    "#d48265",
                    "#91c7ae",
                    "#749f83",
                    "#ca8622",
                    "#bda29a",
                    "#6e7074",
                    "#546570",
                    "#c4ccd3",
                    "#4BABDE",
                    "#FFDE76",
                    "#E43C59",
                    "#37A2DA"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }]
        },


        amountCharts: '',
        amountOption: {
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: ['总保证金','总账户金额','总提现','总冻结','总提现中'],
            axisTick: {
              alignWithLabel: true
            }
          }],
          yAxis: [{
            type: 'value'
          }],
          series: [{
            name: '司机钱包',
            type: 'bar',
            barWidth: '60%',
            data: [],
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = [
                    "#61a0a8",
                    "#d48265",
                    "#91c7ae",
                    "#749f83",
                    "#ca8622",
                    "#bda29a",
                    "#6e7074",
                    "#546570",
                    "#c4ccd3",
                    "#4BABDE",
                    "#FFDE76",
                    "#E43C59",
                    "#37A2DA"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }]
        },

        search_data: {
          reg_time_array: '',
          sex: '',
          status: '',
          platform: ''
        }


      };
    },
    created() {
      _this = this;

      _this.getOrderStatistics();
    },
    mounted() {

      _this.echartsInit()

    },
    methods: {



      echartsInit() {

        this.totalCharts = echarts.init(document.getElementById('totalCharts'))
        this.totalCharts.setOption(_this.totalOption)

        this.amountCharts = echarts.init(document.getElementById('amountCharts'))
        this.amountCharts.setOption(_this.amountOption)

        

      },




      // 搜索司机审核列表
      getOrderStatistics() {

        _this.$post(
            "/statistics/getDriverSubmit",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {
            _this.totalOption.series[0].data = [res.data.total]

            _this.amountOption.series[0].data = [res.data.wallet.bond,res.data.wallet.balance,res.data.wallet.cash,res.data.wallet.frozen,res.data.wallet.cashing]
            _this.echartsInit();


          }).catch((err) => {

          })
      },

      // 搜索预约时间触发
      regTimeChange(val) {
        _this.reg_time_array = [];

        _this.search_data.reg_time_array = [];
        if (val == 'between') {

          _this.search_data.reg_time_array.push(_this.reg_time_value);

        } else if (val == '') {


        } else {

          _this.search_data.reg_time_array.push(_this.reg_time_value);

          _this.search_data.reg_time_array = JSON.stringify(_this.search_data.reg_time_array);
        }

      },

      // 搜索时间选择触发
      timeChange() {


        _this.search_data.reg_time_array.push(_this.reg_time_array[0]);
        _this.search_data.reg_time_array.push(_this.reg_time_array[1]);

        _this.search_data.reg_time_array = JSON.stringify(_this.search_data.reg_time_array);


      },




      // 重置按钮
      refresh() {
        _this.search_data = {
          reg_time_array: '',
          sex: '',
          status: '',
          platform: ''
        }
        _this.reg_time_array = [];
        _this.reg_time_value = '';
      },

    }
  };
</script>

<style scoped>
  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }

  .table-head {
    margin-bottom: 20px;
  }


  .table-head>div .title {
    display: block;
    width: 100px;
    padding-right: 16px;
    text-align: right;
    box-sizing: border-box;
    color: #606266;
    height: 28px;
    line-height: 28px;
    float: left;
  }

  .table-head-search {
    display: flex;
    justify-content: space-between;
  }

  .table-head .search-radio {
    width: 100%;
  }

  .container-tabs .el-tabs__item.is-top.is-active {
    border: 1px solid #dcdfe6;
  }

  .charts-box {
    display: flex;

  }
</style>
<style>
  .table-head-search .el-select.el-select--small,
  .table-head .el-radio-group {
    width: calc(100% - 100px);
  }

  .table-head-search .el-select.el-select--small .el-input.el-input--small.el-input--suffix {
    width: 100% !important;
  }

  .table-head>div .el-input--small {
    width: calc(100% - 100px);

    float: left;
  }



  .table-head>div .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;

  }

  .container .el-tabs__header {
    margin-bottom: 0 !important;
  }

  .table-head .el-checkbox__inner {
    display: none;
  }

  .table-head .el-radio__inner {
    display: none;
  }

  .table-head .el-checkbox-group {
    display: inline-block;
  }

  .table-head .el-checkbox,
  .table-head .el-radio {
    border: 0px solid transparent;
    background-color: transparent;
    border-radius: 5px !important;
  }

  .table-head .el-checkbox.is-checked,
  .table-head .el-radio.is-checked {
    border: 0px solid #409EFF;
    /* background-color: #ecf5ff;  */
  }

  .table-head .el-checkbox__label,
  .table-head .el-radio__label {
    padding: 0;
  }




  .container-tabs .el-tabs__nav.is-top {
    border: 0;
  }

  .container-tabs .el-tabs__item.is-top {
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .container-tabs .el-tabs__header.is-top {
    border-bottom: 0;
  }

  .el-col.el-col-6>span {
    display: inline-block;
    width: 100px;
    text-align: left;
  }

  .sub #tab-new .table-title {
    color: #65c138;
  }

  .sub #tab-proceed .table-title {
    color: #b6ae3a;
  }

  .sub #tab-serving .table-title {
    color: #409eff;
  }

  .sub #tab-unpaid .table-title {
    color: #f67745;
  }

  .sub #tab-paid .table-title {
    color: #606266;
  }

  .sub #tab-order_cancel .table-title {
    color: #606266;
  }

  .order-table-lists .el-table__body .cell {
    color: #000;
    font-weight: 500;
    font-size: 18px;
  }

  .el-date-range-picker__time-header {
    display: block;
  }
</style>
